import { Schemas } from 'src/openapi/generated/types';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

import { filterReservationFlowInvalidRequestDetails } from '../filter-reservation-flow-invalid-request-details';

export const getCustomerFieldsValidationErrorItems: (
  error: ReservationFlowInvalidRequestError,
) => Schemas.ReservationFlowInvalidRequestCustomerFieldsValidationItem[] = (
  error,
) => {
  const { details } = error;

  return filterReservationFlowInvalidRequestDetails(details)
    .map((detail) => {
      return detail.invalid_items.filter(
        (item) => item.type === 'customer_fields_validation_error',
      );
    })
    .flat() as Schemas.ReservationFlowInvalidRequestCustomerFieldsValidationItem[];
};
